import React, { useEffect, useState } from 'react';
import axios from '../../api/axiosInstance';
import ConfirmModal from './ConfirmModal';
import { toast } from 'react-toastify';
import './UserGroupManager.css';

const USERS_PER_PAGE = 5;

const UserGroupManager = () => {
  const [groupUsers, setGroupUsers] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [groups, setGroups] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userToUnassign, setUserToUnassign] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    axios.get('/groups')
      .then(res => setGroups(res.data))
      .catch(() => toast.error('Failed to load groups'));
  }, []);

  const fetchGroupUsers = async (groupId) => {
    try {
      const res = await axios.get(`/groups/${groupId}`);
      setGroupUsers(res.data.users || []);
      setCurrentPage(1);
    } catch {
      toast.error('Failed to fetch group users');
    }
  };

  const handleGroupSelect = (e) => {
    const id = e.target.value;
    setSelectedGroup(id);
    fetchGroupUsers(id);
  };

  const handleUnassignClick = (user) => {
    setUserToUnassign(user);
    setShowModal(true);
  };

const handleUnassignConfirm = async () => {
  try {
   await axios.post('/groups/unassign-user', {
  userId: userToUnassign._id,
  groupId: selectedGroup,
});

    toast.success(`${userToUnassign.name || userToUnassign.email} unassigned successfully`);
    setShowModal(false);
    setUserToUnassign(null);

    // Refresh group users
    await fetchGroupUsers(selectedGroup);
  } catch (err) {
    console.error('Unassign error:', err);
    toast.error('Failed to unassign user');
    setShowModal(false);
    setUserToUnassign(null);
  }
};

  const totalPages = Math.ceil(groupUsers.length / USERS_PER_PAGE);
  const paginatedUsers = groupUsers.slice(
    (currentPage - 1) * USERS_PER_PAGE,
    currentPage * USERS_PER_PAGE
  );

  return (
    <div className="user-group-manager">
      <h3 className="user-group-manager-title">Manage Group Users</h3>

      <select
        value={selectedGroup}
        onChange={handleGroupSelect}
        className="group-select"
      >
        <option value="">-- Select Group --</option>
        {groups.map((group) => (
          <option key={group._id} value={group._id}>
            {group.name}
          </option>
        ))}
      </select>

      {selectedGroup && (
        <div className="user-list-container">
          {paginatedUsers.length === 0 ? (
            <p>No users assigned to this group.</p>
          ) : (
            paginatedUsers.map((user) => (
              <div key={user._id} className="user-card">
               <div className="user-info">
                  <strong>{user.name}</strong><br />
                  <span className="email">{user.email}</span><br />
                  <span className="role">Role: {user.role || 'No role found'}</span>
                </div>
                <button className="unassign-button" onClick={() => handleUnassignClick(user)}>
                  Unassign
                </button>
              </div>
            ))
          )}

          {totalPages > 1 && (
            <div className="pagination">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
                ⬅ Prev
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>
                Next ➡
              </button>
            </div>
          )}
        </div>
      )}

      <ConfirmModal
        isOpen={showModal}
        title="Confirm Unassign"
        message={`Are you sure you want to unassign ${userToUnassign?.name || userToUnassign?.email}?`}
        onConfirm={handleUnassignConfirm}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
};

export default UserGroupManager;
